import { FunctionComponent, useContext, useEffect, useState } from 'react'
import { ThemeContext } from 'styled-components'

import Body3 from 'design-system/Typography/Body/Body3'

import Spacer from 'components/Spacer'

import { IBedProps } from '../types'
import RangeInput, {
  IRangeOption,
  IRangeOptionSelection,
  areRangeValuesEqual,
  getRangeOptionFromValue,
} from './Shared/RangeInput'

const rangeOptions: IRangeOption[] = [
  { label: 'Studio', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
]

const rangeOptionsMin = [{ label: 'No Min', value: undefined }, ...rangeOptions]
const rangeOptionsMax = [{ label: 'No Max', value: undefined }, ...rangeOptions]

interface IProps {
  onError?: (error: string) => void
}

const BedRangeInput: FunctionComponent<
  IProps & Omit<IBedProps, 'applyBedSelections' | 'resetBedSelections'>
> = ({ selectedBedRange, setSelectedBedRange, onError }) => {
  const theme = useContext(ThemeContext)

  const [selectedRangeOption, setSelectedRangeOption] = useState<IRangeOptionSelection>(
    getRangeOptionFromValue(selectedBedRange, rangeOptionsMin, rangeOptionsMax),
  )

  useEffect(() => {
    if (areRangeValuesEqual(selectedBedRange, selectedRangeOption)) return

    const rangeOption = getRangeOptionFromValue(selectedBedRange, rangeOptionsMin, rangeOptionsMax)

    setSelectedRangeOption(rangeOption)
  }, [selectedBedRange])

  useEffect(() => {
    if (areRangeValuesEqual(selectedBedRange, selectedRangeOption)) return

    setSelectedBedRange({
      min: selectedRangeOption.min?.value,
      max: selectedRangeOption.max?.value,
    })
  }, [selectedRangeOption])

  const handleError = (selectionError: string) => {
    if (onError) onError(selectionError)
  }

  return (
    <>
      <Body3>Beds</Body3>
      <Spacer size={theme.spacings[8]} />
      <RangeInput
        label="bed"
        minOptions={rangeOptionsMin}
        maxOptions={rangeOptionsMax}
        selectedRangeOption={selectedRangeOption}
        setSelectedRangeOption={setSelectedRangeOption}
        onError={handleError}
      />
    </>
  )
}

export default BedRangeInput
